import type { CheckoutSession } from "../../protos/checkout/checkout_session.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseCheckoutSession = (): CheckoutSession => {
  return {
    cookieValue: "",
    secret: "",
  };
};

export const decodeCheckoutSession = (
  reader: Reader,
  length: number
): CheckoutSession => {
  const end = reader.pos + length;
  const message = createBaseCheckoutSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.cookieValue = reader.string();

        break;
      case 2:
        message.secret = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCheckoutSession = (
  writer: Writer,
  message: CheckoutSession
): Writer => {
  writer.uint32(10).string(message.cookieValue);
  writer.uint32(18).string(message.secret);

  return writer;
};
